import isEmpty from 'lodash/isEmpty';

import wind from '../wind';

const WindMixin = {
  props: {
    winds: {
      type: Array,
      default: () => null
    }
  },
  mounted() {
    if (!this.renderFuncs) this.renderFuncs = [];
    this.renderFuncs.push(this.syncWind);
  },
  watch: {
    winds(val) {
      if (!isEmpty(val)) {
        this.syncWind();
      }
    }
  },
  methods: {
    syncWind() {
      if (!this.winds) return;
      if (!this.windDrawer) {
        this.windDrawer = wind(this.map);
      }
      if (!isEmpty(this.winds)) {
        this.windDrawer.update(this.winds);
      }
    }
  }
};

export default WindMixin;
